module.exports = __webpack_public_path__ + "static/media/bg1.54954c0d.svg";